var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHandKey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.4375 18.5626H4.38281C4.38281 18.5626 7.78282 19.7128 10.0547 19.4764C12.4793 19.2242 16.4102 16.8942 17.9324 15.9412C18.3301 15.6922 18.5625 15.2557 18.5625 14.7866C18.5625 13.841 17.6449 13.167 16.7426 13.4499L10.0833 15.5376",
    stroke: "#171717",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4375 13.2345L6.43018 12.1633C7.30555 11.8499 8.23856 11.7305 9.16462 11.8134L12.9668 12.1536C13.254 12.1794 13.4464 12.4606 13.3663 12.7376L13.3534 12.7821C13.0146 13.9532 12.1159 14.8794 10.9554 15.2533L10.0833 15.5342",
    stroke: "#171717",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.056 7.09262C9.73384 7.4148 9.21147 7.4148 8.88929 7.09262C8.56711 6.77044 8.56711 6.24807 8.88929 5.92589C9.21148 5.60371 9.73384 5.60371 10.056 5.92589C10.3782 6.24807 10.3782 6.77044 10.056 7.09262Z",
    fill: "#171717",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.78829 4.49785C6.67853 5.6076 6.67854 7.4076 7.78829 8.51735C8.89804 9.62684 10.6975 9.62639 11.8071 8.5167C12.0221 8.3017 12.1939 8.06006 12.3256 7.80331L15.1126 7.80396L16.409 6.5076L15.1126 5.21124L12.3256 5.21059C12.194 4.9543 12.0218 4.71317 11.8071 4.4985C10.6975 3.38881 8.89804 3.38836 7.78829 4.49785Z",
    stroke: "#171717",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHandKey);
export default __webpack_public_path__ + "static/media/icon_hand_key.485acb6048652be54bd11c022bf2b9c2.svg";
export { ForwardRef as ReactComponent };